module.exports = __webpack_public_path__ + "static/media/pdf.775103f7.svg";